






























































































import {Component, Vue} from "vue-property-decorator";
import Company from "@/model/company";
import CompanyCooperate from "@/model/companyCooperate";
import companyApi from "@/api/companyApi";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import store from "@/store";
import PartnerSearch from "@/components/partner/partnerSearch.vue";
import PartnerCooperationCompleted from "@/components/partner/partnerCooperationCompleted.vue";
import {namespace} from "vuex-class";
import {compareWithKeys} from "@/common/utils";
import _ from "lodash";
const authStore = namespace("Auth");
@Component({
  name: "PartnerCooperate",
  components: {
    QErrors,
    PartnerSearch,
    PartnerCooperationCompleted,
  },
})
export default class PartnerCooperate extends Vue {
  @authStore.Getter
  public getCurrentyCompany!: Company;
  public cooperateIndex: number = null;

  public isShow = false;
  public type = "create";
  public errors = {};
  public companyCooperate = new CompanyCooperate();
  public companyCooperateInit = new CompanyCooperate();

  public show(type, cooperateIndex = null) {
    this.type = type;
    this.cooperateIndex = cooperateIndex;
    this.errors = {};

    if (this.isEdit) {
      this.companyCooperate = new CompanyCooperate(store.state.Company.companiesCooperate);
    } else {
      this.companyCooperate = new CompanyCooperate();
      this.companyCooperate.company_id = store.state.Company.mcCompanyId;
    }
    this.isShow = true;
    this.companyCooperateInit = _.cloneDeep(this.companyCooperate)
  }

  get isEdit() {
    return this.type === "edit";
  }

  public searchCompany() {
    (this.$refs.pSearch as PartnerSearch).show();
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public async createCooperate() {
    const result = await companyApi.createCooperate(this.companyCooperate);

    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("companies.cooperation_created_fail"),
      });
      this.errors = result.meta.errors;
    } else {
      if(this.getCurrentyCompany) {
        this.$emit('refreshMcList');
      } else {
        store.dispatch("Company/setCompany", new Company(result.data));
      }

      this.errors = {};
      (this.$refs.pCooperationCompleted as PartnerCooperationCompleted).show(this.companyCooperate.cooperate_company_id);
      this.isShow = false;
    }
  }

  public async deleteCooperate() {
    this.$modal.showDelete({
      text: this.$t("deleteCooperate", { company_name: this.companyCooperate.cooperate_company_name }),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await companyApi.deleteCooperate(this.companyCooperate.id);
        if (result.meta.status === 200) {
          if(!this.getCurrentyCompany) {
            store.dispatch("Company/spliceCooperate", this.cooperateIndex);
          }else{
            this.$emit('refreshMcList');
          }
          qNotify.success({
            text: this.$t("companies.cooperate_deleted"),
          });
          this.isShow = false;
        } else {
          qNotify.error({
            text: this.$t("companies.cooperate_deleted_fail"),
          });
          this.errors = result.meta.errors;
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public isChanged() {
    return compareWithKeys(this.companyCooperate, this.companyCooperateInit, [
      'role_id',
      'cooperate_company_id',
    ])
  }
}
